import { render } from "./countup.vue?vue&type=template&id=58d8855a"
import script from "./countup.vue?vue&type=script&setup=true&lang=ts"
export * from "./countup.vue?vue&type=script&setup=true&lang=ts"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "58d8855a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58d8855a', script)) {
    api.reload('58d8855a', script)
  }
  
  module.hot.accept("./countup.vue?vue&type=template&id=58d8855a", () => {
    api.rerender('58d8855a', render)
  })

}

script.__file = "resources/ts/components/elements/countup.vue"

export default script